import FormSubmit from '../formSubmit'
import { RESET_PASSWORD } from '@/graphql/AuthMutations'
import { apolloClient } from '@/apollo/vue-apollo'
import handleSuccessfulAuth from './handleSuccessfulAuth'

export default {
  namespaced: true,

  state: () => ({
    ...FormSubmit.state
  }),
  mutations: {
    ...FormSubmit.mutations
  },
  getters: {
    ...FormSubmit.getters
  },
  actions: {
    resetPassword({ commit }, payload) {
      commit('start')

      apolloClient.mutate({
        mutation: RESET_PASSWORD,
        variables: {
          token: payload.token,
          password: payload.password, 
        },
      }).then((response) => {
          let user =  response.data.loginUser.user
          handleSuccessfulAuth(commit, user)
          commit('succeeded')
      }).catch((error) => {
        commit('failed')
        for (const graphQlError of error.graphQLErrors) {
          if (graphQlError.debugMessage) {
            commit('addErrorMessage', graphQlError.debugMessage)
          }
        }
      })
    },
  },
}
